<div class="full-width-image-background">
    <img class="view-signature" [src]="getSource(model['' + key])" />
</div>
